import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './LoginPage.css';
import { setSession } from '../../sessionSlice';
import { useNavigate } from 'react-router-dom';


const LoginPage = () => {
  const [password, setPassword] = useState('');
  const [error, setError]     = useState('');
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();  

  useEffect(() => {
    const desktop = `${process.env.PUBLIC_URL}/images/index_bg.jpg`;
    const mobile = `${process.env.PUBLIC_URL}/images/mob_index.png`;

    const updateBackground = () => {
      setBackgroundImageUrl(window.innerWidth <= 768 ? mobile : desktop);
    };

    updateBackground();
    window.addEventListener('resize', updateBackground);

    return () => window.removeEventListener('resize', updateBackground);
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    if (password === 'milesplay') {
      console.log("Dispatching!!");
      dispatch(setSession({ sessionId: 'admin', organizationId: 'admin'}));
      navigate("/admin");
    } else {
      setError('Incorrect password');
    }
  };

  return (
    <div
      className="LoginPage_container"
      style={backgroundImageUrl ? { backgroundImage: `url(${backgroundImageUrl})` } : undefined}
    >
      <div className="LoginPage_overlay" />

      <header className="LoginPage_header">
        <img
          src="/escape_peace-old/images/logo.png"
          alt="Extramile Play"
          className="LoginPage_brandLogo"
        />
        <button
          type="button"
          className="LoginPage_backButton"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </header>

      <main className="LoginPage_content">
        <img
          src="/escape_peace-old/images/escape1.png"
          alt="Escape To Inner Peace"
          className="LoginPage_logo"
        />

        <form className="LoginPage_form" onSubmit={handleSubmit}>
          <h2 className="LoginPage_title">Superadmin Login</h2>
          <p className="LoginPage_subtitle">Enter the access password to continue.</p>
          {error && <div className="LoginPage_error">{error}</div>}

          <div className="LoginPage_field">
            <label className="LoginPage_label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              className="LoginPage_input"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="LoginPage_button">
            Login
          </button>
        </form>
      </main>
    </div>
  );
};

export default LoginPage;
